module.exports = __webpack_public_path__ + "img/Freespin_l2.846b048d.png";